module.exports = __webpack_public_path__ + "media/assets/Twirl-05f3a0cd4eebe59935ccad35bf9d2222.svg";